<div class="content">
  <div class="container-fluid">
    <h3>User Dashboard Content In here</h3>
    <br>
  </div>
</div>
